import { IDeliveryDiscountData } from '@/store/ducks/deliveryDiscount/types';

interface Props {
  discount: IDeliveryDiscountData;
  showPhrases?: boolean;
}

const ShippingFiltersText = ({ discount, showPhrases }: Props) => {
  const messages = [];

  if (discount.brand) {
    messages.push(
      <>
        da marca <b>{discount.brand}</b>
      </>,
    );
  }

  if (discount?.categories?.length) {
    const categories = discount.categories.map((category) => category.webapp_name || category.name);

    messages.push(
      <>
        {!!(discount.brand && showPhrases) && 'que fazem parte '}
        da categoria <b>{categories.join(', ')}</b>
      </>,
    );
  }

  if (discount?.groups?.length) {
    const groups = discount.groups.map((group) => group.webapp_name || group.name);

    messages.push(
      <>
        {!(showPhrases && discount.brand && !discount.categories.length) && 'que fazem parte '}
        do grupo <b>{groups.join(', ')}</b>
      </>,
    );
  }

  return (
    <>
      {messages.map((message, index) => (
        <span key={index}>
          {message}
          {index < messages.length - 1 && ', e '}
        </span>
      ))}
    </>
  );
};

export default ShippingFiltersText;
